import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { brandAlpha, dialogFormColumn } from '../../../theme/mixins';

export const dialogTitleStyles: SxProps<Theme> = {
    fontWeight: 700,
    pb: 1,
};

/** Lets the fields scroll under a pinned footer -- see `dialogFormColumn`. */
export const dialogFormStyles: SxProps<Theme> = dialogFormColumn;

export const dialogActionsStyles: SxProps<Theme> = {
    px: 3,
    pb: 3,
    pt: 1,
};

export const formAlertStyles: SxProps<Theme> = {
    mb: 2,
};

export const sectionTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
    mt: 3,
    mb: 0.5,
};

export const sectionHintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 2,
};

/**
 * The read-only summary of what is being invoiced.
 *
 * Tinted rather than outlined so it reads as context the therapist cannot change, next to
 * fields they can. `brandAlpha` rather than a hex, or it would stay blue on a green clinic.
 */
export const summaryBoxStyles: SxProps<Theme> = {
    p: 2,
    borderRadius: 2,
    backgroundColor: brandAlpha('primary', 0.06),
};

export const summaryServiceStyles: SxProps<Theme> = {
    fontWeight: 600,
};

export const summaryMetaStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

/**
 * The field grid. One column on a phone, two above it.
 *
 * The floor is `min(220px, 100%)` rather than a bare `220px`: a hard floor pushes the dialog
 * sideways the moment it is narrower than that, which full-screen on a 375px phone it is.
 */
export const fieldGridStyles: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, minmax(min(220px, 100%), 1fr))',
    },
    gap: 2,
};

/** A field that must not share a row -- the name, which is the only required one. */
export const fullWidthFieldStyles: SxProps<Theme> = {
    gridColumn: '1 / -1',
};

export const photoRowStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    flexWrap: 'wrap',
    mt: 2,
};

/**
 * The thumbnail.
 *
 * Fixed height with `objectFit: cover`, because a receipt photographed in portrait and one
 * photographed at arm's length are wildly different shapes and the row should not jump.
 */
export const photoPreviewStyles: SxProps<Theme> = {
    width: 96,
    height: 96,
    borderRadius: 2,
    objectFit: 'cover',
    border: '1px solid',
    borderColor: 'divider',
};

export const photoHintStyles: SxProps<Theme> = {
    color: 'text.secondary',
};
